import { FrontendFormDefinition } from "src/modules/sm-base/models/frontend-form-definition.model";
import { Type } from "class-transformer";
import { EnaioDataSource } from "./enaio-data-source.model";
import { AdvancedFormTableColumn } from "./advanced-form-table.column.model";

export class AdvancedForm {
    id = "";
    @Type(() => EnaioDataSource)
    dataSources: EnaioDataSource[] = [];
    @Type(() => FrontendFormDefinition)
    form: FrontendFormDefinition;
    @Type(() => AdvancedFormTableColumn)
    tableColumns: AdvancedFormTableColumn[];
}